import { businessPlanAxios } from 'services/controllers/businessPlan';

import * as t from './types';

export const FinancialPerformanceApi = {
  getCalculationsOfPerformanceSolvency: async (params: t.IPerformanceSolvencyParams) => {
    const { businessPlanId, unit, requestData } = params;
    const { data } = await businessPlanAxios.put<t.IPerformanceSolvencyResponse>(
      `/${businessPlanId}/performance/solvency/${unit}`,
      requestData,
    );
    return data;
  },

  getCalculationsOfPerformanceProfitability: async (params: t.IPerformanceProfitabilityParams) => {
    const { businessPlanId, unit, requestData } = params;
    const { data } = await businessPlanAxios.put<t.IPerformanceProfitabilityResponse>(
      `/${businessPlanId}/performance/profitability/${unit}`,
      requestData,
    );
    return data;
  },

  getCalculationsOfPerformanceLiquidity: async (params: t.IPerformanceLiquidityParams) => {
    const { businessPlanId, unit, requestData } = params;
    const { data } = await businessPlanAxios.put<t.IPerformanceLiquidityResponse>(
      `/${businessPlanId}/performance/liquidity/${unit}`,
      requestData,
    );
    return data;
  },

  getCalculationsOfPerformanceInvestment: async (params: t.IPerformanceInvestmentParams) => {
    const { businessPlanId, unit, requestData } = params;
    const { data } = await businessPlanAxios.put<t.IPerformanceInvestmentResponse>(
      `/${businessPlanId}/performance/investment/${unit}`,
      requestData,
    );
    return data;
  },

  getCalculationsOfPerformanceEfficiency: async (params: t.IPerformanceEfficiencyParams) => {
    const { businessPlanId, unit, requestData } = params;
    const { data } = await businessPlanAxios.put<t.IPerformanceEfficiencyResponse>(
      `/${businessPlanId}/performance/efficiency/${unit}`,
      requestData,
    );
    return data;
  },
};
